/***************-----------wishlist product js----------********************/ 
$(document).ready(function(){
  var wishlistProduct=[];
  var wishlist_store = localStorage.getItem('wishlist_arr');
  if(wishlist_store){
  wishlistProduct.push(wishlist_store);
   // setTimeout(function(){
   //  addActive(wishlist_store);
   //   }, 2000);
    renderwishlist();
  }
  else{
    var html = `<div class="wishlist_no_item"><div class="wishlist_no_product">No item is wishlist</div>
                <div class="wishlist_no_items_title">You have not added any product in your wishlist</div>
                <div class="wishlist_no_no_item_link">
                <a href="/collections/all">Shop Now</a></div></div>`
       $('.wishlist_section').append(html);
    $('body').addClass('nowishlist');
    }
  
 $('body').on('click','button.cstm__wishlist_button',function(){
   var pro_handle = $(this).attr('product__handle');
   var wishlist_store = localStorage.getItem('wishlist_arr');
  if(wishlist_store){
  wishlistProduct=[];
  wishlistProduct = wishlist_store.split(",");
  }
   if(!wishlistProduct.includes(pro_handle)){
     $('.wishlist__text').text('Product added to wishlist successfully');
      $('.wishlist_success_popup').css('display','flex');
     setTimeout(function(){
     $('.wishlist_success_popup').hide();
     }, 2000);
     $(this).addClass('active_wishlist');
     wishlistProduct.push(pro_handle);
     localStorage.setItem('wishlist_arr', '');
    localStorage.setItem('wishlist_arr', wishlistProduct);
     renderwishlist();
   }

 }); 

  $('body').on('click','button.cstm__wishlist_button.active_wishlist',function(){
   var pro_handle = $(this).attr('product__handle');
    var wishlist_store = localStorage.getItem('wishlist_arr');
  if(wishlist_store){
  wishlistProduct=[];
  wishlistProduct = wishlist_store.split(",");
  }
   if(wishlistProduct.includes(pro_handle)){
     if($('body').hasClass('account_cstm')){
      $(this).parents('.wishlist__submain').hide();
    }
     else{
     $('.wishlist__text').text('Product removed from wishlist successfully');
     $('.wishlist_success_popup').css('display','flex');
     setTimeout(function(){
     $('.wishlist_success_popup').hide();
     }, 2000);
     }
   var length = wishlistProduct.length;
      for(var i=0;i<length;i++){
        if(wishlistProduct[i] == pro_handle){
           $(this).removeClass('active_wishlist');
          wishlistProduct.splice(i,  1);
          localStorage.setItem('wishlist_arr', '');
          localStorage.setItem('wishlist_arr', wishlistProduct);
          renderwishlist();
        }
      }
   }
    
 });

  function renderwishlist() {
    $('.wishlist_section').html('');
    var wishlist_store = localStorage.getItem('wishlist_arr');
  if(wishlist_store){
  wishlistProduct=[];
  wishlistProduct = wishlist_store.split(",");
    var uniq = wishlistProduct.reduce(function(a,b){
    if (a.indexOf(b) < 0 ) a.push(b);
    return a;
  },[]); 
  var length = uniq.length;
    
      for(var i=0;i<length;i++){
        var active_btn = uniq[i];
     fetch('/products/'+ active_btn +'?view=wishlist_items', {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (content) {    
      content.text().then(function (html) {
       // console.log(html);
        $('.wishlist_section').append(html);
      });
       
    });
      }  
  }
     else{
    var html = `<div class="wishlist_no_item"><div class="wishlist_no_product">No item is wishlist</div>
                <div class="wishlist_no_items_title">You have not added any product in your wishlist</div>
                <div class="wishlist_no_no_item_link">
                <a href="/collections/all">Shop Now</a></div></div>`
       $('.wishlist_section').append(html);
       $('body').addClass('nowishlist');
    }
    setTimeout(function(){
    addActive(wishlist_store);
     }, 2000);
  }
  function addActive(activeProduct) {
    var active_product =activeProduct.split(",");
  var uniq = active_product.reduce(function(a,b){
    if (a.indexOf(b) < 0 ) a.push(b);
    return a;
  },[]); 
    // console.log(active_product);
   var length = uniq.length;
      for(var i=0;i<length;i++){
        var active_btn = uniq[i];
        var active_class ='.'+active_btn+'__wishlist';
        console.warn(active_class);
        $(active_class).addClass('active_wishlist');
      }
  }

  $('body').on('click','button#add_wishlist_btn_account',function(){
   $('.account_remove_wishlist').show();
    var product__handle = $(this).attr('product__handle');
     $('button.remove__wishlist_btn').attr('remove_item',product__handle);
  });
  $('body').on('click','button.cancel__wishlist_btn',function(){
    $('.account_remove_wishlist').hide();
  })
  $('body').on('click','button.remove__wishlist_btn',function(){
    $('.account_remove_wishlist').hide();
    var class_atr =$(this).attr('remove_item');
    var class_remove = '.'+class_atr+'__wishlist';
    $(class_remove).trigger('click');
  })
});

